import {
  getToken,
  getTokenSuperadmin,
  postLogin,
} from "helpers/backend_helpers";
import { toast } from "react-toastify";
import {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
} from "./reducer";

export const logoutUser = () => async (dispatch: any) => {
  try {
    // FIX KASUS 2: Clear all session items to prevent token conflicts
    sessionStorage.removeItem("authUser");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("menu");
    sessionStorage.removeItem("userRole");
    sessionStorage.removeItem("companyId");
    sessionStorage.removeItem("currentCompany");

    dispatch(logoutUserSuccess(true));
  } catch (error: any) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch: any) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error: any) {
    dispatch(apiError(error));
  }
};
